export { default } from './RoundedRectangle'
